import { render, staticRenderFns } from "./EditarQuestionarioQuestoes.vue?vue&type=template&id=d6dab45a"
import script from "./EditarQuestionarioQuestoes.vue?vue&type=script&lang=js"
export * from "./EditarQuestionarioQuestoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports